import { render, staticRenderFns } from "./editOwners.vue?vue&type=template&id=9a289354&scoped=true"
import script from "./editOwners.vue?vue&type=script&lang=js"
export * from "./editOwners.vue?vue&type=script&lang=js"
import style0 from "./editOwners.vue?vue&type=style&index=0&id=9a289354&prod&lang=scss"
import style1 from "./editOwners.vue?vue&type=style&index=1&id=9a289354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a289354",
  null
  
)

export default component.exports